export { KitDetailsModal } from "./KitDetailsModal";
export type { KitDetailsModalProps, KitProductView } from "./KitDetailsModal";
